import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    irbis: null,
    family: null,
    familySorted: null,
    publications: null,
    menu: null
  },
  getters: {
    IRBIS: state => {
      return state.irbis
    },
    FAMILY: state => {
      return state.family
    },
    FAMILYSORTED: state => {
      return state.familySorted
    },
    MENU: state => {
      return state.menu
    },
    PUBLICATIONS: state => {
      return state.publications
    },
  },
  mutations: {
    irbisSet: (state, status) => {
      state.irbis = status
    },
    familySet: (state, status) => {
      state.family = status
    },
    familySortedSet: (state, status) => {
      state.familySorted = status
    },
    menuSet: (state, status) => {
      state.menu = status
    },
    publicationsSet: (state, status) => {
      state.publications = status
    },
  },
  actions: {
  },
  modules: {
  }
})
